import { FC } from 'react';
import { ImageProps, ImageSourceProps } from '../../utils/interfaces/Image';

interface IStrapiImageProps {
  image: ImageProps | null | undefined;
  alt: string;
  sizes?: string;
}

export const StrapiImage: FC<IStrapiImageProps> = (props) => {
  const {
    image,
    alt,
    sizes,
  } = props;

  return (
    <picture>
      <StrapiImageSource
        sources={[
          image?.formats?.thumbnail,
          image?.formats?.small,
          image?.formats?.medium,
          image?.formats?.large,
          image,
        ]}
        sizes={sizes}
        mime={image?.mime}
      />
      <img
        loading='lazy'
        src={image?.url || `${process.env.PUBLIC_URL}/images/PlacementArea.png`}
        alt={image?.alternativeText || alt}
      />
    </picture>
  );
}

interface IStrapiImageSourceProps {
  sources: (ImageSourceProps | null | undefined)[];
  sizes?: string;
  mime?: string;
}

const StrapiImageSource: FC<IStrapiImageSourceProps> = (props) => {
  const {
    sources,
    sizes = '100vw',
    mime,
  } = props;

  const filteredSources = sources.filter(Boolean) as ImageSourceProps[];
  if (filteredSources) {
    return (
      <source
        srcSet={
          filteredSources.map((src) => (
            `${src.url} ${src.width}w`
          )).join(', ')
        }
        sizes={sizes}
        type={mime}
      />
    );
  }
  return <></>;
}